export class ValidateResult {
    constructor(valid, errorMessage) {
        this.valid = valid;
        this.errorMessage = errorMessage;
    }
}

const LENGTH_OF_AT_LEAST_8_CHARACTERS =
    'Password has a minimum length of at least 8 characters';
const SEQUENTIAL_CHARACTERS =
    'Password cannot be completely sequential characters';
const CONSECUTIVE_SAME_CHARACTERS =
    'Password cannot include 3 or more consecutive same characters';
const SAME_AS_UID = 'Password cannot be the same as email id';
const REGEX = /(?=.*\d)(?=.*[a-z])(?=.*[A-Z])((?=.*\W)|(?=.*_))/;
const PASSWORD_PATTERN_NOT_MATCH =
    'Password should include at least one upper case and lower case letter with a special character and a digit';

const PASSWORD_NOT_MEET_POLICY =
    'Invalid password. Please ensure it meets the required criteria and try again';

export const validatePassword = (s, userEmailId) => {
    if (s) {
        if (s.length < 8) {
            return new ValidateResult(false, PASSWORD_NOT_MEET_POLICY);
        }
        if (s === userEmailId) {
            return new ValidateResult(false, PASSWORD_NOT_MEET_POLICY);
        }
        if (sequentialCharacters(s)) {
            return new ValidateResult(false, PASSWORD_NOT_MEET_POLICY);
        }
        if (consecutiveSameCharacters(s)) {
            return new ValidateResult(false, PASSWORD_NOT_MEET_POLICY);
        }
        if (!REGEX.test(s)) {
            return new ValidateResult(false, PASSWORD_NOT_MEET_POLICY);
        }
        return new ValidateResult(true);
    } else {
        return new ValidateResult(false, PASSWORD_NOT_MEET_POLICY);
    }
};

const sequentialCharacters = (s) => {
    let c1 = s.charAt(0);
    let c2 = s.charAt(1);
    if (alphaNumeric(c1) && alphaNumeric(c2)) {
        if (ascii(c2) - ascii(c1) === 1) {
            if (s.length === 2) {
                return true;
            }
            return isSequentialCharacters(s, true);
        } else if (ascii(c2) - ascii(c1) === -1) {
            if (s.length === 2) {
                return true;
            }
            return isSequentialCharacters(s, false);
        } else {
            return false;
        }
    } else {
        return false;
    }
};
const consecutiveSameCharacters = (s) => {
    let start = 0;
    let end = 2;
    while (end < s.length) {
        let c = s.charAt(start);
        let same = true;
        for (let i = start + 1; i <= end; i++) {
            if (s.charAt(i) !== c) {
                same = false;
                break;
            }
        }
        if (same) {
            return true;
        } else {
            start++;
            end++;
        }
    }
    return false;
};

const isSequentialCharacters = (s, asc) => {
    for (let i = 2; i < s.length; i++) {
        if (!alphaNumeric(s.charAt(i))) {
            return false;
        }
        if (asc) {
            if (ascii(s.charAt(i)) - ascii(s.charAt(i - 1)) !== 1) {
                return false;
            }
        } else {
            if (ascii(s.charAt(i - 1)) - ascii(s.charAt(i)) !== 1) {
                return false;
            }
        }
    }
    return true;
};
const alphaNumeric = (c) => {
    return (
        (ascii(c) >= ascii('a') && ascii(c) <= ascii('z')) ||
        (ascii(c) >= ascii('A') && ascii(c) <= ascii('Z')) ||
        (ascii(c) >= ascii('0') && ascii(c) <= ascii('9'))
    );
};

const ascii = (c) => {
    return c.charCodeAt(0);
};
